import { Box, useMediaQuery } from '@mui/material';

import { Link, useLocation } from 'react-router';
import { ROOT_PATHNAME } from '../../../routes';

export default function Logo(props) {
  const { src } = props;

  const location = useLocation();
  const big = location.pathname === ROOT_PATHNAME;

  const breakpoint = useCurrentBreakpoint();
  const size = {
    xs: { width: '135', height: '22.54' },
    sm: { width: '300', height: '50' },
    md: { width: '500', height: '83.48' },
    lg: { width: '600', height: '100' },
    xl: { width: '600', height: '116.9' },
  };
  const { width, height } = breakpoint ? size[breakpoint] : { width: 0, height: 0 };

  // BIG logo shown only on the home page
  if (big) {
    return (
      <Box pt={1}>
        <img width={width} height={height} src={src} alt="Opik Logo" />
      </Box>
    );
  }

  // REGULAR logo shown on all other pages
  return (
    <Box height={{ xs: '22.5px', sm: '33.5px', lg: '52px' }}>
      <Link to="/">
        <img src={src} alt="Opik Logo" height="100%" />
      </Link>
    </Box>
  );
}

function useCurrentBreakpoint() {
  let bp = 'unknown';

  bp = useMediaQuery((theme) => theme.breakpoints.down('sm')) ? 'xs' : bp;
  bp = useMediaQuery((theme) => theme.breakpoints.between('sm', 'md')) ? 'sm' : bp;
  bp = useMediaQuery((theme) => theme.breakpoints.between('md', 'lg')) ? 'md' : bp;
  bp = useMediaQuery((theme) => theme.breakpoints.between('lg', 'xl')) ? 'lg' : bp;
  bp = useMediaQuery((theme) => theme.breakpoints.up('xl')) ? 'xl' : bp;

  return bp;
}
